import { SteuerIdAntragGrundEnum } from '../v2024';

export const SteuerIdAntragGrundEnumLabels = {
    ERWRBEU: 'ERWRBEU' as SteuerIdAntragGrundEnum,
    VERZSCHW: 'VERZSCHW' as SteuerIdAntragGrundEnum,
    NEUKFZ: 'NEUKFZ' as SteuerIdAntragGrundEnum
};

